export const getDeliveryDaysTranslation = (maxDeliveryDays: number): string => {
  if (maxDeliveryDays === 1) {
    return 'ARTICLE_DETAIL.UP_SELLING.DELIVERY_TIME.STOCK'
  }
  if (maxDeliveryDays > 1) {
    return 'ARTICLE_DETAIL.UP_SELLING.DELIVERY_TIME.DELAYED'
  }
  return ''
}
